/** @typedef {import('../../lib/types.js').NoteContentBlock} NoteContentBlock */

/** @type {NoteContentBlock[]} */
export const meetingStandupDemoContent = [
  { type: 'heading', level: 1, text: 'Weekly standup' },
  {
    type: 'paragraph',
    text: '45-minute sync with product, design, and eng. Sia captured the thread while we walked through Mission Control polish and inbox layout dependencies.',
  },
  { type: 'heading', level: 2, text: 'Highlights' },
  {
    type: 'bullets',
    items: [
      'Notes rail search and New note row landed in the aside',
      'Meeting card now shows Transcribe meeting beside Instructions',
      'Glass panels and mountain backdrop approved for Mission Control shell',
    ],
  },
  { type: 'heading', level: 2, text: 'Shipped this week' },
  {
    type: 'checklist',
    items: [
      { text: 'Notes rail polish — tabs, search, selection state', checked: true },
      { text: 'Mission Control glass panels + three-column layout', checked: true },
      { text: 'Participant avatars on meeting rows when transcript exists', checked: true },
      { text: 'E2E smoke for inbox flows', checked: false },
    ],
  },
  { type: 'heading', level: 2, text: 'In progress' },
  {
    type: 'bullets',
    items: [
      'Inbox briefing layout — folder nav grouped column',
      'Avatar scene tweaks on home hero (marketing request)',
      'Formatted note bodies instead of raw markdown in the editor',
    ],
  },
  { type: 'heading', level: 2, text: 'Blockers' },
  {
    type: 'numbered',
    items: [
      'Waiting on final copy for empty inbox state',
      'Calendar create-event menu item still disabled in transcribe dropdown',
    ],
  },
]
